import { render, staticRenderFns } from "./ChangePwd.vue?vue&type=template&id=1919b89a&scoped=true"
import script from "./ChangePwd.vue?vue&type=script&lang=js"
export * from "./ChangePwd.vue?vue&type=script&lang=js"
import style0 from "./ChangePwd.vue?vue&type=style&index=0&id=1919b89a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../tianxinghuayi/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1919b89a",
  null
  
)

export default component.exports